import type { UppFloorPlanElementGeometryPayload } from '../canvas/upp-floor-plan-stage.component';

export type FloorPlanGeometrySnapshot = { x: number; y: number; w: number; h: number; r: number };

/**
 * Decides which product-level geometry outputs should fire for one {@link UppFloorPlanElementGeometryPayload}
 * (plain {@link UppKonvaSceneElementRef} in `element`), comparing against the last known snapshot for that element
 * (or none after a structural change).
 */
export function floorPlanPresentationGeometryPartition(
  previous: FloorPlanGeometrySnapshot | undefined,
  payload: UppFloorPlanElementGeometryPayload,
  epsCm = 1e-4,
  epsDeg = 1e-4,
): { emitTranslate: boolean; emitRotate: boolean; next: FloorPlanGeometrySnapshot } {
  const next: FloorPlanGeometrySnapshot = {
    x: payload.xCm,
    y: payload.yCm,
    w: payload.widthCm,
    h: payload.heightCm,
    r: payload.rotationDeg,
  };
  if (!previous) {
    return { emitTranslate: true, emitRotate: true, next };
  }
  const emitTranslate =
    Math.abs(previous.x - next.x) > epsCm ||
    Math.abs(previous.y - next.y) > epsCm ||
    Math.abs(previous.w - next.w) > epsCm ||
    Math.abs(previous.h - next.h) > epsCm;
  const emitRotate = Math.abs(previous.r - next.r) > epsDeg;
  return { emitTranslate, emitRotate, next };
}
